interface NavigationItem {
    id: number;
    label: string;
    section: string;
  }
  
  interface BaseMediaItem {
    type: 'image' | 'video' | 'youtube';
    thumbnail: string;
  }
  
  interface ImageVideoMediaItem extends BaseMediaItem {
    type: 'image' | 'video';
    url: string;
  }
  
  interface YoutubeMediaItem extends BaseMediaItem {
    type: 'youtube';
    youtubeId: string;
  }
  
  type MediaItem = ImageVideoMediaItem | YoutubeMediaItem;
  
  interface Room {
    id: number;
    title: string;
    description: string;
    coverImage: string;
    media: MediaItem[];
  }
  
  interface SiteContent {
    header: {
      navigation: NavigationItem[];
    };
    hero: {
      backgroundImages: string[];
      title: JSX.Element | string;
      callToAction: string;
    };
    rooms: {
      title: string;
      rooms: Room[];
    };
    prestige: {
      title: string;
      description: string;
      performances: {
        id: number;
        title: string;
        crew: string;
        date: string;
        thumbnail: string;
        videoUrl: string;
      }[];
    };
    aboutUs: {
      title: string;
      description: string;
      contact: {
        address: string;
        email: string;
        phone: string;
      };
      social: {
        instagram: string;
        facebook: string;
        youtube: string;
      };
      mapUrl: string;
    };
  }
  
  export const siteContent: SiteContent = {
    header: {
      navigation: [
        { id: 1, label: "Trang Đầu", section: "home" },
        { id: 2, label: "Studios", section: "rooms" },
        { id: 3, label: "Trình Diễn", section: "prestige" },
        { id: 4, label: "Liên Hệ", section: "about" }
      ]
    },
    hero: {
      backgroundImages: [
        "images/vstudio-feiyan-7.jpg",
        "images/vstudio-X-2.jpg",
        "images/vstudio-V-2.jpg",
        "images/vstudio-W-4.jpg",
        "images/vstudio-M-4.jpg",
        "images/vstudio-S-2.jpg",
      ],
      title: '<span>Du Nhiên<br>Yển Nguyệt</span>',
      callToAction: "Xem Studios"
    },
    rooms: {
      title: "Studios",
      rooms: [
        {
          id: 1,
          title: "V",
          description: "120 m2 - Sức chứa rộng, đáp ứng mọi yêu cầu về không gian và quay chụp.",
          coverImage: "images/vstudio-V-3.jpg",
          media: [
            {
              type: "image" as const,
              url: "images/vstudio-V-1.jpg",
              thumbnail: "images/vstudio-V-1.jpg"
            },
            {
              type: "image" as const,
              url: "images/vstudio-V-2.jpg",
              thumbnail: "images/vstudio-V-2.jpg"
            },
            {
              type: "image" as const,
              url: "images/vstudio-V-3.jpg",
              thumbnail: "images/vstudio-V-3.jpg"
            },
            
          ]
        },
        {
          id: 2,
          title: "W",
          description: "100 m2 - Thiết kế tone trắng hiện đại, phù hợp với nhu cầu của giới trẻ.",
          coverImage: "images/vstudio-W-1.jpg",
          media: [
            {
              type: "image",
              url: "images/vstudio-W-1.jpg",
              thumbnail: "images/vstudio-W-1.jpg"
            },
            {
              type: "image",
              url: "images/vstudio-W-2.jpg",
              thumbnail: "images/vstudio-W-2.jpg"
            },
            {
              type: "image",
              url: "images/vstudio-W-3.jpg",
              thumbnail: "images/vstudio-W-3.jpg"
            },
            {
              type: "image",
              url: "images/vstudio-W-4.jpg",
              thumbnail: "images/vstudio-W-4.jpg"
            }
          ]
        },
        {
          id: 3,
          title: "X",
          description: "60 m2 - Tone đen xám mạnh mẽ, đáp ứng mọi nhu cầu về vũ đạo (popping, hip hop,...)",
          coverImage: "images/vstudio-X-1.jpg",
          media: [
            {
              type: "image",
              url: "images/vstudio-X-1.jpg",
              thumbnail: "images/vstudio-X-1.jpg"
            },
            {
              type: "image",
              url: "images/vstudio-X-2.jpg",
              thumbnail: "images/vstudio-X-2.jpg"
            }
          ]
        },
        {
          id: 4,
          title: "M",
          description: "40 m2 - Thiết kế linh hoạt, phù hợp với những dự án quay chụp quy mô vừa và nhỏ.",
          coverImage: "images/vstudio-M-1.jpg",
          media: [
            {
              type: "image",
              url: "images/vstudio-M-1.jpg",
              thumbnail: "images/vstudio-M-1.jpg"
            },
            {
              type: "image",
              url: "images/vstudio-M-2.jpg",
              thumbnail: "images/vstudio-M-2.jpg"
            },
            {
              type: "image",
              url: "images/vstudio-M-3.jpg",
              thumbnail: "images/vstudio-M-3.jpg"
            },
            {
              type: "image",
              url: "images/vstudio-M-4.jpg",
              thumbnail: "images/vstudio-M-4.jpg"
            }
          ]
        },
        {
          id: 5,
          title: "S",
          description: "22 m2 - Phù hợp với nhu cầu quay tập cá nhân hoặc đội nhóm nhỏ.",
          coverImage: "images/vstudio-S-1.jpg",
          media: [
            {
              type: "image",
              url: "images/vstudio-S-1.jpg",
              thumbnail: "images/vstudio-S-1.jpg"
            },
            {
              type: "image",
              url: "images/vstudio-S-2.jpg",
              thumbnail: "images/vstudio-S-2.jpg"
            },
          ]
        },
      ]
    },
    prestige: {
      title: "Hoạt Động - V Dance Studio",
      description: "Để bạn đạt được màn trình diễn đỉnh cao, V Studio cung cấp tất cả điều kiện cần thiết, từ phòng tập đến dịch vụ ánh sáng, quay phim và chỉnh sửa video.",
      performances: [
        {
          id: 1,
          title: "Urban Dance Championship",
          crew: "Rhythm Breakers",
          date: "December 2023",
          thumbnail: "https://i.ytimg.com/vi/roJm4ytVKgM/maxresdefault.jpg",
          videoUrl: "https://www.youtube.com/watch?v=RtHLNneFnco"
        },
        {
          id: 2,
          title: "Contemporary Showcase",
          crew: "Eclipse Dance Company",
          date: "November 2023",
          thumbnail: "/path/to/performance-2-thumb.jpg",
          videoUrl: "https://www.youtube.com/watch?v=kdkN1LVkCCg"
        },
        {
          id: 3,
          title: "Breaking Battle Finals",
          crew: "Power Moves Crew",
          date: "October 2023",
          thumbnail: "/path/to/performance-3-thumb.jpg",
          videoUrl: "https://www.youtube.com/watch?v=LXPLyrL1fAQ"
        },
        {
          id: 4,
          title: "Annual Dance Gala",
          crew: "Various Artists",
          date: "September 2023",
          thumbnail: "/path/to/performance-4-thumb.jpg",
          videoUrl: "https://www.youtube.com/watch?v=RUpO4yYbtLY"
        }
      ]
    },
    aboutUs: {
      title: "Liên Hệ",
      description: "Trung tâm sáng tạo dành cho vũ công và nghệ sĩ biểu diễn, cung cấp không gian chuyên nghiệp để luyện tập, biểu diễn và phát triển.",
      contact: {
        address: "59 Nguyễn Hữu Cầu, Phường Tân Định, Quận 1, Hồ Chí Minh",
        email: "vstudio.ytdance@gmail.com",
        phone: "093 882 7956"
      },
      social: {
        instagram: "https://instagram.com/vstudio_official1",
        facebook: "https://www.facebook.com/profile.php?id=61569945255795",
        youtube: "https://youtube.com/vstudio"
      },
      mapUrl: "https://www.google.com/maps/embed?pb=!1m14!1m8!1m3!1d62704.66899769078!2d106.6364988!3d10.8081096!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x31752963bd1f0859%3A0xb2cb336622a9ed5!2sV%20Studio!5e0!3m2!1sen!2s!4v1732353066032!5m2!1sen!2s"
    }
  };